import { Controller } from "stimulus"

// AdminKit mounts SimpleBar on .sidebar-content (js-simplebar) during DOMContentLoaded.
// Scroll that container so a deep .sidebar-item.active is visible. Setting scrollTop
// on the SimpleBar wrapper leaves the main column where it is.
export default class extends Controller {
  connect() {
    this.onReady = () => {
      window.requestAnimationFrame(() => this.scrollActiveItemIntoView(12))
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.onReady, { once: true })
    } else {
      this.onReady()
    }
  }

  disconnect() {
    if (this.onReady) {
      document.removeEventListener("DOMContentLoaded", this.onReady)
    }
  }

  scrollActiveItemIntoView(triesLeft) {
    const active = this.deepestActiveItem()
    if (!active) return

    const scroller = this.scrollContainer()
    if (!scroller || scroller.clientHeight === 0) {
      if (triesLeft > 0) {
        window.requestAnimationFrame(() => this.scrollActiveItemIntoView(triesLeft - 1))
      }
      return
    }

    const scrollerRect = scroller.getBoundingClientRect()
    const activeRect = active.getBoundingClientRect()
    const margin = 8
    const above = activeRect.top < scrollerRect.top + margin
    const below = activeRect.bottom > scrollerRect.bottom - margin
    if (!above && !below) return

    const offset = activeRect.top - scrollerRect.top + scroller.scrollTop
    const target = offset - (scroller.clientHeight - activeRect.height) / 2
    scroller.scrollTop = Math.max(0, target)
  }

  scrollContainer() {
    return this.element.querySelector(".simplebar-content-wrapper")
  }

  deepestActiveItem() {
    const items = this.element.querySelectorAll(".sidebar-item.active")
    let deepest = null

    items.forEach((item) => {
      if (!item.querySelector(".sidebar-item.active")) deepest = item
    })

    return deepest
  }
}
